const getShortDomain = ({ isCrossSubdomain = false } = {}) => {
    const domain = document.domain || "";
    if (domain === "localhost" || window.guardian?.config?.page?.isPreview) {
        return domain;
    }
    if (isCrossSubdomain) {
        return ["", ...domain.split(".").slice(-2)].join(".");
    }
    return domain.replace(/^(www|m\.code|dev|m)\./, ".");
};
export { getShortDomain };
